// extracted by mini-css-extract-plugin
export var borderTop = "_q-3";
export var linkIcon = "_q-5";
export var linkIconSm = "_q-6";
export var linkOutCard = "_q-7 _q-4";
export var linkRow = "_q-2";
export var pageContainer = "_q-1";
export var providerIcon = "_q-8";
export var roundedBorder = "_q-4";
export var settingsContent = "_q-0";